declare const useIsMounted: () => () => boolean;
export { useIsMounted };
